//
//
//
//
//
//
//
//
//
//
//
export default {
  created: function created() {//  window.addEventListener("resize", this.getHeight);
    // 	// 执行浏览器高度事件
    // 	this.getHeight();
  },
  mounted: function mounted() {
    this.swiperList.push(require('@/assets/2.png'));
    this.swiperList.push(require('@/assets/3.png'));
    this.requestBanner();
  },
  data: function data() {
    return {
      swiperList: [require('@/assets/1.png')],
      contentStyleObj: {
        width: "",
        height: ""
      }
    };
  },
  methods: {
    requestBanner: function requestBanner() {
      var data = {// brcId:'',
        // location:''
      };
      this.requestAPI.bannerQuery(data).then(function (res) {// this.joinList = res.data.content
        // this.total = res.data.totalCount
      });
    },
    getHeight: function getHeight() {
      // 获取浏览器高度  768 1080一般笔记本浏览器高度
      if (window.innerWidth < 1080) {
        this.contentStyleObj.height = "240px";
        this.contentStyleObj.width = '960px';
      } else {
        this.contentStyleObj.height = "480px";
        this.contentStyleObj.width = '1920px';
      }
    }
  }
};